// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jQeieRtb0gCk0aPsQ8nt{display:flex;align-items:center;justify-content:space-between;width:100%}`, "",{"version":3,"sources":["webpack://./src/pages/conversations/pages/search/pages/profile/ui/SectionConversation/ui/Header/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CACA,6BAAA,CACA,UAAA","sourcesContent":[".wrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `jQeieRtb0gCk0aPsQ8nt`
};
export default ___CSS_LOADER_EXPORT___;
